import request from "@/utils/request";

// 运营商

// 获取运营商详情
export const getDealerById = params => {
	return request({
		url: "/dealer",
		method: "GET",
		params,
	});
};

// 保存运营商信息
export const setDealer = data => {
	return request({
		url: "/dealer",
		method: "POST",
		data,
	});
};

// 获取运营商资费
export const getDealerFeePolicy = params => {
	return request({
		url: "/dealer/feepolicy",
		method: "GET",
		params,
	});
};

// 注册运营商
export const registerDealer = data => {
	return request({
		url: "/dealer/registration",
		method: "POST",
		data,
	});
};

// 查询支付配置
export const getDealerPaymentMerchant = params => {
	return request({
		url: "/dealer/payment/merchant",
		method: "GET",
		params,
	});
};

// 设置支付配置
export const setDealerPaymentMerchant = data => {
	return request({
		url: "/dealer/payment/merchant",
		method: "POST",
		data,
	});
};

// 创建stripe 子账户
export const createStripeAccount = data => {
	return request({
		url: "/stripe/account",
		method: "POST",
		data,
	});
};

// 启用H5扫码功能
export const setDealerQrcodeStartCharging = data => {
	return request({
		url: "/dealer/qrcode/start/charging",
		method: "POST",
		data,
	});
};

// 运营商是否授权桩企进行管理
export const getFactoryDealerRel = params => {
	return request({
		url: "/factoryDealerRel",
		method: "GET",
		params,
	});
};

// 运营商是否授权桩企进行管理
export const setFactoryDealerRel = data => {
	return request({
		url: "/factoryDealerRel",
		method: "POST",
		data,
	});
};